<template>
  <div class="audio-player" :class="{ 'active': currentSong }">
    <span id="title" v-if="currentSong">{{ currentSong.name }}</span>
    <audio id="player" controls />
  </div>
</template>

<style>
  :root {
    --plyr-audio-controls-background: --gray-dark;
    --plyr-audio-control-color: white;
  }
  #player {
    width: 100%;
  }
  #title {
    color: white;
  }
  .audio-player {
    height: 0;
    transition: height, .5s linear;
  }
  .audio-player.active {
    height: 76px;
  }
</style>

<script>
  import Plyr from "plyr";
  import {mapState} from 'vuex';
  import {REST_ENDPOINT} from "@/constants"

  export default {
    data() {
      return {
        player: null
      }
    },
    computed: {
      ...mapState({
        currentSong: state => state.audioPlayer.currentSong,
        token: state => state.token
      })
    },
    mounted() {
      this.setupPlyr();
    },
    methods: {
      setupPlyr() {
        this.player = new Plyr('#player', {
          controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'pip', 'airplay', 'download']
        });
      },
    },
    watch: {
      currentSong: function (newSong) {
        if (newSong == null) {
          this.player.stop();
          return;
        }
        
        const src = `${REST_ENDPOINT}/get_file.php?filename=${newSong.id}/${newSong.files.mp3.name}&token=${this.token}`;
        this.player.source = {
          type: 'audio',
          title: newSong.title,
          sources: [{
            src: src,
            type: 'audio/mp3',
          }],
        };
        this.player.download = src;
        this.player.play();
      }
    }
  };
</script>
